module.exports = __webpack_public_path__ + "img/pic-3.ca6945e5.png";